import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const processDesignActivityCount = z
  .object({
    id: z.string().hidden().describe('Unique identifier'),

    activityId: z
      .string()
      .nullable()
      .optional()
      .describe('The activity being counted'),

    status: z
      .enum(['Active', 'Paused', 'Error', 'Complete'])
      .nullable()
      .optional()
      .describe('The token status being counted'),

    tokenCount: z
      .number()
      .nullable()
      .optional()
      .describe('Number of tokens at this activity with this status'),

    designUuid: z
      .string()
      .nullable()
      .optional()
      .describe('The design UUID for this process design'),

    processDesignId: z.uuid().hidden().describe('Foreign key to ProcessDesign'),

    processDesign: belongsTo('ProcessDesign'),
  })
  .describe('Token counts per activity and status for a process design')
  .as('ProcessDesignActivityCount');

export { processDesignActivityCount as processDesignActivityCountSchema };
